import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart, ArcElement } from 'chart.js'
import styled from 'styled-components'
import GreenStarIcon from 'components/icons/GreenStarIcon'

Chart.register(ArcElement)

const StyledDiv = styled.div`
  position: relative;
`
const StarText = styled.div`
  position: absolute;
  top: 56%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #010e30;
`

const DoughnutChart = ({ width = 200, totalValue = 0, currentValue = 0 }) => {
  const data = {
    datasets: [
      {
        data: [currentValue, totalValue - currentValue],
        backgroundColor: ['#5DB594', '#F2F3F5'],
        display: true,
        border: false,
      },
    ],
  }

  return (
    <StyledDiv style={{ width: width }}>
      <Doughnut
        data={data}
        options={{
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
          rotation: -130,
          circumference: 265,
          cutout: '55%',
          maintainAspectRatio: true,
          responsive: true,
        }}
      />
      <StarText>
        {currentValue} <GreenStarIcon />
      </StarText>
    </StyledDiv>
  )
}

export default DoughnutChart
